module.exports = __webpack_public_path__ + "static/media/favicon.8b0c9f4d.ico";